import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditorContent = _resolveComponent("EditorContent")!
  const _component_Errors = _resolveComponent("Errors")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_EditorContent, {
      editor: _ctx.editor,
      class: _normalizeClass([{ 'p-invalid': _ctx.questionStore.v$Dialog?.sentence?.$error }])
    }, null, 8, ["editor", "class"]),
    _createVNode(_component_Errors, {
      errors: _ctx.questionStore.v$Dialog?.sentence?.$errors
    }, null, 8, ["errors"])
  ]))
}